var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('doctor-card',{attrs:{"styles":{ '--cols': 2, '--rows': 2 },"data":_vm.info,"noBtn":true,"noFeats":true,"horizontal":true,"appointmentAndReviews":true},on:{"changeForm":_vm.changeForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }